
import Vue from "vue";

export default Vue.extend({
  name: "AddIcon2",
  props: {
    color: {
      type: String,
      default: "currentColor",
    },
    width: {
      type: String,
      default: "16",
    },
    height: {
      type: String,
      default: "16",
    },
  },
});
